export default "__VITE_ASSET__C7LzMKn9__"